export const TRACE_TARGET_REGEX = /^https:\/\/(.*)\/api\/v1\/(.*)/;

export const HEADER_HEIGHT = 40;

export const NAVIGATION_BAR_HEIGHT = 64;

export const AUDIO_CACHE_NAME = 'audios';
export const AUDIO_ASSETS_MAP = {
  FAIL: `${AUDIO_CACHE_NAME}/fail.mp3`,
  GAME_BGM: `${AUDIO_CACHE_NAME}/game-bgm.mp3`,
  HIGH_HZ_BEEP: `${AUDIO_CACHE_NAME}/high-hz-beep.mp3`,
  LOW_HZ_BEEP: `${AUDIO_CACHE_NAME}/low-hz-beep.mp3`,
  MESSAGE: `${AUDIO_CACHE_NAME}/message.mp3`,
  SUCCESS: `${AUDIO_CACHE_NAME}/success.mp3`,
  TICKING: `${AUDIO_CACHE_NAME}/ticking.mp3`,
  TRANSITION: `${AUDIO_CACHE_NAME}/transition.mp3`,
};
